import { lazy, Suspense, type ComponentType } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { Dashboard } from '@/pages/Dashboard';
import { Login } from '@/pages/Login';
import { useAuth } from '@/context/AuthContext';

function lazyPage(loader: () => Promise<Record<string, ComponentType>>, name: string) {
  const Component = lazy(() => loader().then((m) => ({ default: m[name] as ComponentType })));
  return (
    <Suspense fallback={<div style={{ padding: 40, color: 'var(--color-text-muted)' }}>Loading…</div>}>
      <Component />
    </Suspense>
  );
}

const router = createBrowserRouter([
  {
    element: <AdminLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'products', element: lazyPage(() => import('@/pages/Products'), 'Products') },
      { path: 'orders', element: lazyPage(() => import('@/pages/Orders'), 'Orders') },
      { path: 'inventory', element: lazyPage(() => import('@/pages/Inventory'), 'Inventory') },
      { path: '*', element: <div style={{ padding: 40 }}>Not found</div> },
    ],
  },
]);

export function App() {
  const { authenticated } = useAuth();
  // Everything is behind the login: unauthenticated visitors only ever see the
  // sign-in screen (the API independently rejects unauthenticated calls).
  if (!authenticated) return <Login />;
  return <RouterProvider router={router} />;
}
